export const isLobbyPage = (pathname: string): boolean => {
  return pathname === '/' || pathname === ''
}
